export const LOADING = "LOADING";
export const UPDATE_PAGE = "UPDATE_PAGE";
export const OPEN_CODE = "OPEN_CODE";
export const CLOSE_CODE = "CLOSE_CODE";
export const OPEN_GAME = "OPEN_GAME";
export const CLOSE_GAME = "CLOSE_GAME";
export const OPEN_TERMINAL = "OPEN_TERMINAL";
export const CLOSE_TERMINAL = "CLOSE_TERMINAL";
export const ENTER = "ENTER";
export const RUN_PROGRAM = "RUN_PROGRAM";
export const EXIT = "EXIT";
